<template>
    <div>
      <van-nav-bar
        title="我的团队"
        left-text=""
        left-arrow
        @click-left="$router.push('/member/agency')"
      />
      <van-list v-model="isLoading" @load="getAgentTeam" :finished="finished" finished-text="没有更多了">
        <van-tabs v-model="active">
          <van-tab title="所有会员">
            <div v-for="(item,index) in teamData" :key="index" class="agancyData">
            <van-row>
              <van-col span="8" style="color:grey;">
                  {{ item.phone }}
              </van-col>
              <van-col span="6">
                  {{ item.user_name }}
              </van-col>
              <van-col span="10" style="text-align:right;">
                  充值总额: {{ item.rec_total }}
              </van-col>
            </van-row>
            <van-row>
              <van-col span="8">
                  {{ item.number }}
              </van-col>
              <van-col span="6">
                   {{ item.level }}
              </van-col>
              <van-col span="10" style="text-align:right;color:grey;">
                  {{ item.time }}
              </van-col>
            </van-row>
            <hr>
            </div>
          </van-tab>
          <van-tab title="充值会员">
            <div v-for="(item,index) in rechargeTeamData" :key="index" class="agancyData">
            <van-row>
              <van-col span="8" style="color:grey;">
                  {{ item.phone }}
              </van-col>
              <van-col span="6">
                  {{ item.user_name }}
              </van-col>
              <van-col span="10" style="text-align:right;">
                  充值总额: {{ item.rec_total }}
              </van-col>
            </van-row>
            <van-row>
              <van-col span="8">
                  {{ item.number }}
              </van-col>
              <van-col span="6">
                   {{ item.level }}
              </van-col>
              <van-col span="10" style="text-align:right;color:grey;">
                  {{ item.time }}
              </van-col>
            </van-row>
            <hr>
            </div>
          </van-tab>
          <van-tab title="无充值会员">
            <div v-for="(item,index) in noRechargeTeamData" :key="index" class="agancyData">
            <van-row>
              <van-col span="8" style="color:grey;">
                  {{ item.phone }}
              </van-col>
              <van-col span="6">
                  {{ item.user_name }}
              </van-col>
              <van-col span="10" style="text-align:right;">
                  充值总额: {{ item.rec_total }}
              </van-col>
            </van-row>
            <van-row>
              <van-col span="8">
                  {{ item.number }}
              </van-col>
              <van-col span="6">
                   {{ item.level }}
              </van-col>
              <van-col span="10" style="text-align:right;color:grey;">
                  {{ item.time }}
              </van-col>
            </van-row>
            <hr>
            </div>
          </van-tab>
        </van-tabs>
      </van-list>
    </div>
</template>

<script>
    export default {
      name: "MyTeam",
      data(){
        return{
          active:0,
          teamData:[],
          rechargeTeamData:[],
          noRechargeTeamData:[],
          isLoading:false,
          finished:false,
          page:1
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        getAgentTeam(){
          let that = this;
          let page = that.page;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_team",
                token: sessionStorage.getItem("token"),
                num: 20,
                page: page,
              }
            })
            .then(function (res) {
              let resData = res.data;
              that.isLoading = false;
              if (res.data.code == 1) {
                let teamData = resData.data;
                that.page = page + 1;
                that.teamData = that.teamData.concat(resData.data);
                if (resData.data.length < 20){
                   that.finished = true;
                }
                let noRechargeTeamData = [];
                let rechargeTeamData = [];
                for(let i = 0,len = teamData.length;i < len; i++){
                  if (Number(teamData[i].rec_total) === 0){
                    noRechargeTeamData.push(teamData[i])
                  }else{
                    rechargeTeamData.push(teamData[i])
                  }
                }
                that.noRechargeTeamData = noRechargeTeamData;
                that.rechargeTeamData = rechargeTeamData;
              } else if (res.data.code == 0) {
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(()=>{
              that.isLoading = false; 
              that.finished = true;
              that.$toast.fail(that.$NoNetworkErrorMsg)
            })
        },
      },
      mounted:function () {
        let that = this;
        that.isLogin();
      }
    }
</script>

<style scoped>
.agancyData{
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyTeam.vue